export const DIALER = 'DIALER';
export const PARTICIPANT = 'PARTICIPANT';
export const FUTURE_APPOINTMENT_CONSENT_DIALER = 'FUTURE_APPOINTMENT_CONSENT_DIALER';

export const initiatorTypes = [DIALER, PARTICIPANT];
export const dialerTypes = [DIALER, FUTURE_APPOINTMENT_CONSENT_DIALER];
